(function() {
  const root = document.querySelector('[data-feedback-widget]');
  if (!root) return;

  const openBtn = root.querySelector('[data-feedback-open]');
  const modal = root.querySelector('[data-feedback-modal]');
  const closeBtn = root.querySelector('[data-feedback-close]');
  const overlay = root.querySelector('[data-feedback-overlay]');
  const form = root.querySelector('[data-feedback-form]');
  const iframe = root.querySelector('.feedback-submit__iframe');
  const success = root.querySelector('[data-feedback-success]');
  const error = root.querySelector('[data-feedback-error]');
  const phoneInput = form ? form.querySelector('input[name="contact[Contact Number]"]') : null;
  const nameInput = form ? form.querySelector('input[name="contact[Full Name]"]') : null;
  const messageInput = form ? form.querySelector('textarea[name="contact[Comment]"]') : null;
  const bodyInput = form ? form.querySelector('.feedback-form__body-input') : null;
  const phoneRequiredText = root.dataset.phoneRequiredText || 'Вкажіть, будь ласка, телефон.';
  const bodyPhoneLabel = root.dataset.bodyPhoneLabel || 'Телефон';
  const bodyNameLabel = root.dataset.bodyNameLabel || "Ім'я";
  const bodyCommentLabel = root.dataset.bodyCommentLabel || 'Коментар';

  if (!openBtn || !modal || !form) return;

  const openModal = () => {
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  const hideMessages = () => {
    if (success) success.hidden = true;
    if (error) error.hidden = true;
  };

  const submitToIframe = () => {
    if (!iframe) {
      form.submit();
      return Promise.resolve(window.location.href);
    }

    return new Promise((resolve, reject) => {
      let settled = false;
      let timer = null;

      const cleanup = () => {
        iframe.removeEventListener('load', onLoad);
        if (timer) clearTimeout(timer);
      };

      const onLoad = () => {
        if (settled) return;
        settled = true;
        cleanup();

        let url = null;
        try {
          url = iframe.contentWindow.location.href;
        } catch (_e) {
          url = null;
        }

        resolve(url);
      };

      timer = setTimeout(() => {
        if (settled) return;
        settled = true;
        cleanup();
        reject(new Error('Submission timed out'));
      }, 30000);

      iframe.addEventListener('load', onLoad);
      form.submit();
    });
  };

  openBtn.addEventListener('click', openModal);
  closeBtn && closeBtn.addEventListener('click', closeModal);
  overlay && overlay.addEventListener('click', closeModal);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    hideMessages();

    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    const phone = String(phoneInput ? phoneInput.value : '').trim();
    const name = String(nameInput ? nameInput.value : '').trim();
    const message = String(messageInput ? messageInput.value : '').trim();

    if (!phone) {
      if (error) {
        error.hidden = false;
        error.textContent = phoneRequiredText;
      }
      if (submitBtn) submitBtn.disabled = false;
      return;
    }

    const bodyParts = [
      name ? `${bodyNameLabel}: ${name}` : '',
      phone ? `${bodyPhoneLabel}: ${phone}` : '',
      message ? `${bodyCommentLabel}: ${message}` : ''
    ].filter(Boolean);

    if (bodyInput) {
      bodyInput.value = bodyParts.join('\n') || `${bodyPhoneLabel}: ${phone}`;
    }

    try {
      const targetUrl = await submitToIframe();

      if (targetUrl && targetUrl.includes('/challenge')) {
        window.location.assign(targetUrl);
        return;
      }

      const ok = !targetUrl || targetUrl.includes('contact_posted=true');
      if (!ok) throw new Error('Request failed');

      form.reset();
      if (success) success.hidden = false;

      setTimeout(() => {
        closeModal();
      }, 1600);
    } catch (_err) {
      if (error) {
        error.hidden = false;
      } else {
        form.submit();
      }
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  });
})();
